import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleExclamationFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM11.12 13.1H12.88V7.54H11.12V13.1ZM12 16.38C12.6 16.38 13.12 15.86 13.12 15.26C13.12 14.66 12.6 14.14 12 14.14C11.4 14.14 10.88 14.66 10.88 15.26C10.88 15.86 11.4 16.38 12 16.38Z" />
    </SvgIcon>
  );
});
